import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/core/services/alert.service';
import { AnnouncementService } from 'src/app/core/services/announcement.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss']
})
export class AnnouncementComponent implements OnInit {
  announcementList = [];
  constructor(private alertService: AlertService,
    private userService: UserService,
    private loadingService: LoadingService,
    private announcementService: AnnouncementService) { }

  ngOnInit(): void {
    this.getAnnouncementList();
  }

  getAnnouncementList(){
    this.loadingService.setLoading(true);
    this.announcementService.getAnnouncements().subscribe(response => {
      if (response.success) {
        this.announcementList = response.announcements;
        this.loadingService.setLoading(false);
      }
    },
    (error) => {
      this.loadingService.setLoading(false);
      this.alertService.alert('Hata!', error.error.Message, 'error');
      console.log('Error --->:', error);
    });
  }

  deleteAnnouncement(id: string) {
    const x = confirm('Duyuruyu silmek istediğinize emin misiniz?');
    if (x) {
      this.announcementService.deleteAnnouncement(id).subscribe(response => {
        if (response.success) {
          this.getAnnouncementList();
          this.alertService.alert("Başarılı!", "Duyuru silindi!", "success");
        } else {
          this.alertService.alert("Hata!", "Duyuru silinemedi!", "error");
        }
      })
    }
  }

  sendEmails(id: string) {
    const x = confirm('Mailleri göndermek istediğinize emin misiniz?');
    if (x) {
      this.loadingService.setLoading(true);
      this.announcementService.sendEmails(id).subscribe(response => {
        if (response.success) {
          this.getAnnouncementList();
          this.loadingService.setLoading(false);
          this.alertService.alert("Başarılı!", "Mailler gönderildi!", "success");
        } else {
          this.loadingService.setLoading(false);
          this.alertService.alert("Hata!", "Mailler gönderilemedi!", "error");
        }
      })
    }
  }

  getStatus(num: any) {
    if (num == 1) {
      return "Aktif"
    }
    else if (num == 2) {
      return "Pasif"
    }
    else {
      return "Bilinmiyor"
    }
  }
}
